import React from 'react'

 function PrivacyPolicyModal({ isOpen, onClose, text }) {
    if (!isOpen) return null;
  return (
    <div className="privacy-policy-overlay">
      <div className="privacy-policy-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Условия обработки персональных данных</h2>
        <div className="policy-text">
          {text}
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyModal;

